import React, { DetailedHTMLProps, PropsWithChildren } from 'react';
import { RegisterOptions } from 'react-hook-form/dist/types/validator';
import { Path, useFormContext } from 'react-hook-form';

import { BaseFromProps } from './BaseFromProps';

export function Input<T>({ children, label, name, options, defaultValue, width, type = 'text', ...props }: PropsWithChildren<InputProps<T>>) {
  const {
    register,
    formState: { errors },
  } = useFormContext<T>();
  return (
    <div className={`${width || 'sixteen'} wide column`}>
      <div className="field">
        <div className="ui labeled input">
          <div className="ui label">{label}</div>
          <div className={`ui input ${children ? 'right labeled' : ''}`}>
            <input key={name} {...props} defaultValue={defaultValue} type={type} {...register(name as Path<T>, options)} />
            {children}
          </div>
        </div>
        {!!errors[name] && <div className="ui pointing red basic label">{errors[name]?.message as string}</div>}
      </div>
    </div>
  );
}

export type InputProps<T> = {
  type?: 'date' | 'text' | 'number';
  defaultValue: string | number;
} & BaseFromProps<T> &
  DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
